import {
	Box,
	Button,
	Card,
	CardContent,
	Container,
	TextField,
} from "@mui/material";
import { extractUpdatedFields, isEmptyObject, pickFields } from "nhb-toolbox";
import { useForm } from "react-hook-form";
import { toast } from "src/Toaster/Toaster";
import type { IProductCategory } from "src/Types/product.categories.types";
import { muiStyles } from "src/Utils/Styles";
import { useApiMutation } from "src/hooks/useApiMutation";

const useStyles = muiStyles;

interface Props {
	handleClose: () => void;
	category: IProductCategory;
}

const UpdateCategory = ({ handleClose, category }: Props) => {
	const classes = useStyles();

	const { register, handleSubmit, reset } = useForm({
		defaultValues: pickFields(category, ["name"]),
	});

	const { mutate: updateCategory, isPending } = useApiMutation<
		{ name?: string },
		void
	>({
		method: "PATCH",
		endPoint: `/api/fair/product-category/${category.id}`,
		invalidateQueries: ["ProductCategories", category.id],
	});

	const handleUpdateCategory = (input: { name: string }) => {
		const previousData: { name?: string } = pickFields(category, ["name"]);

		const updatedData = extractUpdatedFields(previousData, input);

		if (isEmptyObject(updatedData)) {
			return toast.fire({
				icon: "warning",
				title: "Nothing to update!",
				position: "top",
			});
		}

		updateCategory(updatedData);
		handleClose();
		reset();
	};

	return (
		<div>
			<Container sx={{ mt: 4 }} maxWidth="lg">
				<Card>
					<CardContent>
						<Box
							component="form"
							onSubmit={handleSubmit(handleUpdateCategory)}
							sx={{
								mt: 1,
							}}
						>
							<TextField
								margin="normal"
								required
								fullWidth
								{...register("name")}
								label="Category Name"
								id="name"
								name="name"
								variant="filled"
								type="text"
								className={classes.inputText}
								InputProps={{ classes }}
							/>

							<Button
								type="submit"
								fullWidth
								variant="contained"
								disableElevation
								sx={{
									mt: 3,
									mb: 2,
									py: 1,
								}}
							>
								{isPending ? "Updating..." : "Update Category"}
							</Button>
						</Box>
					</CardContent>
				</Card>
			</Container>
		</div>
	);
};

export default UpdateCategory;
